import { Address, address } from '@app/models/address';
import { Agency, agencyBasic, agencyDetailed } from '@app/models/agency';
import { defaultComparisonOption } from '@app/models/default-comparison-option';
import { language } from '@app/models/language';
import { PersonalSettings } from '@app/models/personal-settings';
import { DictionaryEntity, filter, PcsEntity } from '@app/pcs/models';
import { userNotification } from '@app/pcs/settings/models/user-notification';
import { EntityType, PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { gql } from 'apollo-angular';

export enum UserRole {
  Coordinator = 'C',
  Admin = 'P',
  IntegrationPlatformUser = 'I',
  RnejoUser = 'J'
}

export interface User {
  id?: number;
  agency?: Agency;
  name?: string;
  firstName?: string;
  username?: string;
  address?: Address;
  supportUser?: boolean;
  active?: boolean;
  displaySettings?: string;
  rneGdprAcceptedDate?: number[];
  pcsNewsletterSubscription?: boolean;
  loginRedirectTo?: string;
  admin?: boolean;
  rneJo?: boolean;
  integrationPlatformUser?: boolean;
  readonly?: boolean;
  personalSettings?: PersonalSettings;
  userType?: DictionaryEntity;
}

export const user = gql`
  fragment user on User {
    id
    agency {
      ...agencyDetailed
    }
    name
    firstName
    username
    address {
      ...address
    }
    supportUser
    active
    displaySettings
    rneGdprAcceptedDate
    pcsNewsletterSubscription
    loginRedirectTo
    admin
    rneJo
    integrationPlatformUser
    readonly
    personalSettings {
      language {
        ...language
      }
      defaultFilter {
        ...filter
      }
      defaultPageSize
      defaultDossierView
      emailNotifications {
        ...userNotification
      }
      subscribedTrainTypes {
        id
        description
      }
      defaultTrainType {
        id
        description
      }
      defaultComparisonOption {
        ...defaultComparisonOption
      }
      fullScreenMode
      dossierSideMenuCollapsed
    }
    userType {
      id
      description
    }
  }
  ${agencyDetailed}
  ${address}
  ${language}
  ${userNotification}
  ${filter}
  ${defaultComparisonOption}
`;

export const userSummary = gql`
  fragment userSummary on User {
    id
    name
    firstName
    username
    supportUser
  }
`;

export const userFormDetailed = gql`
  fragment userFormDetailed on User {
    id
    agency {
      ...agencyBasic
    }
    firstName
    name
    username
    rneGdprAcceptedDate
    userRoles {
      id
      description
    }
    userType {
      id
      description
    }
    supportUser
    active
    pcsNewsletterSubscription
    personalSettings {
      language {
        ...language
      }
      defaultPageSize
      defaultComparisonOption {
        ...defaultComparisonOption
      }
    }
  }
  ${agencyBasic}
  ${language}
  ${defaultComparisonOption}
`;

const userMapperOptions = {entityName: PcsEntity.User, entityType: EntityType.Object};
export const userPropertyMapper = new PropertyNameMapper({
  firstName: 'firstName',
  name: 'name',
  username: 'logonId',
  password: 'password',
  personalSettings: new PropertyNameMapper({
    language: 'preferedLanguageId'
  }, userMapperOptions)
}, userMapperOptions);
